package com.ijoin.i18n

actual fun createLanguagePreferenceStorage(): LanguagePreferenceStorage =
    JsLanguagePreferenceStorage()

private class JsLanguagePreferenceStorage : LanguagePreferenceStorage {
    override fun saveLanguageCode(code: String) {
        try {
            js("localStorage.setItem('app_language', code)")
        } catch (_: dynamic) {
            // localStorage might be unavailable (e.g., disabled cookies)
        }
    }

    override fun getLanguageCode(): String? {
        return try {
            js("localStorage.getItem('app_language')") as? String
        } catch (_: dynamic) {
            null
        }
    }
}

actual fun detectSystemLanguageCode(): String {
    return try {
        val language = js("navigator.language || navigator.userLanguage") as? String
        language?.substringBefore("-")?.lowercase() ?: "en"
    } catch (_: dynamic) {
        "en"
    }
}
